export enum ThreadType {
  THREAD = 'thread',
  EVENT_REMINDER = 'event_reminder',
  VACATION_REQUEST_REMINDER = 'vacation_request_reminder',
}
